<template>
  <div class="stage">
    <VideoWrapper
      v-if="activeVideo"
      ref="video"
      :source="activeVideo.src"
      :chapter="activeVideo.chapter"
      @ended="onEnded"
    />

    <h1
      v-if="stage.heading"
      class="stage-heading"
      v-html="stage.heading"
    ></h1>

    <ButtonGroup
      v-show="!playing"
      ref="button-group"
      :buttons="stage.options"
      :disableOnPress="true"
      @action="onAction"
    />

    <ButtonMedicalRecords v-if="stage['records-button']" v-show="!playing" @action="onAction" />  

    <BasePopup
      v-if="activePopup"
      :popup="activePopup"
      @action="onAction"
    />

    <BasePopup
      v-if="definitionPopup"
      :popup="definitionPopup"
      @action="onAction"
    />
  </div>
</template>

<script>
import BasePopup from '../popups/BasePopup.vue'
import ButtonGroup from '../partials/ButtonGroup.vue'
import ButtonMedicalRecords from '../partials/ButtonMedicalRecords.vue'
import VideoWrapper from '../partials/VideoWrapper.vue'

export default {
  name: 'StageAllOptions',
  components: {
    BasePopup,
    ButtonGroup,
    ButtonMedicalRecords,
    VideoWrapper,
  },
  props: {
    stage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeVideo: null,
      playing: false,
      played: 0,

      activePopup : null,
      definitionPopup: null,

      eventHandlers: {
        'play-video': this.playVideo,
        'pause-video': this.pauseVideo,
        'resume-video': this.resumeVideo,
        'show-records': this.showRecords,
        'show-popup': this.showPopup,
        'complete-popup': this.completePopup,
        'close-popup': this.hidePopup,
        'show-definition-popup': this.showDefinitionPopup,
        'close-definition-popup': this.hideDefinitionPopup,
        'on-ended': this.checkState,
      },
    }
  },
  methods: {
    onAction(event) {
      if (event.type in this.eventHandlers) {
        this.eventHandlers[event.type](event);
      } else {
        this.$emit('action', event);
      }
    },
    onEnded() {
      this.playing = false;
      if (this.activePopup) {
        this.activePopup = null;
      }

      if (this.played === this.stage.options.length) {
        this.showPopup({ "popup": 0 });
      }
    },
    playVideo(event) {
      this.played += 1;
      this.activeVideo = event;
      this.playing = true;
    },
    pauseVideo() {
      if (this.activeVideo && !this.$refs['video'].paused) {
        this.$refs['video'].pause();
      }
    },
    resumeVideo() {
      if (this.playing && this.$refs['video'].paused) {
        this.$refs['video'].play();
      }
    },
    showRecords(event) {
      this.pauseVideo();
      this.$emit('action', event);
    },
    showPopup(event) {
      this.definitionPopup = null;
      this.activePopup = this.stage.popups[event.popup] || null;
    },
    completePopup() {
      this.played += 1;
      this.onEnded();
    },
    hidePopup() {
      this.activePopup = null;
      this.played = 0;
      this.$refs['button-group'].reset();
    },
    showDefinitionPopup(event) {
      this.activePopup = null;
      this.definitionPopup = this.stage.popups[event.popup] || null;
    },
    hideDefinitionPopup() {
      this.definitionPopup = null;
    },
  },
  created() {
    if (this.stage.onload) {
      this.onAction(this.stage.onload);
    }
  },
}
</script>
